/* eslint-disable
    consistent-return
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from 'jquery';
import _ from 'underscore';

import wyciwyp from 'notebook/mediocre/clipboard/wyciwyp';
import * as logging from 'util/Logging';

const SOURCES_MIME_TYPE = 'application/vnd.benchling.sources+json';
const SOURCE_KEYS = ['id', 'name', 'url', 'permissions', 'rootFolder', 'sourceType'];

const FILES_MIME_TYPE = 'application/vnd.benchling.files+json';
const FILE_KEYS = ['id', 'name', 'url', 'permissions', 'parentFolderId', 'source', 'type'];

const TFI_MIME_TYPE = 'application/vnd.benchling.tfi+json';
const TFI_KEYS = ['id', 'accountId', 'name'];

const OPTIONAL_KEYS = ['type', 'parentFolderId'];

function BenchlingData(e) {
  return {
    hasData(type) {
      return wyciwyp.typesContains(e.dataTransfer.types, type);
    },

    getData(type) {
      if ([SOURCES_MIME_TYPE, FILES_MIME_TYPE, TFI_MIME_TYPE].includes(type) && this.hasData(type)) {
        const jsonData = JSON.parse(e.dataTransfer.getData(type));
        if (this.validateData(type, jsonData)) {
          return jsonData;
        }
      }
      return null;
    },

    setLink(name, absoluteURL) {
      e.dataTransfer.setData('text/html', $('<a>').attr('href', absoluteURL).text(name)[0].outerHTML);
      e.dataTransfer.setData('text/uri-list', absoluteURL);
      e.dataTransfer.setData('text/plain', absoluteURL);
      return true;
    },

    setData(type, json) {
      if (this.validateData(type, json)) {
        e.dataTransfer.setData(type, JSON.stringify(json));
        return true;
      }
      return false;
    },

    validateData(type, json) {
      function validateItem(item, keys) {
        for (const key of Array.from(keys)) {
          // eslint-disable-next-line benchlint/no-in-operator
          if (!(key in item) && !(key in OPTIONAL_KEYS)) {
            logging.warn(`BenchlingData: missing required key '${key}' for ${type}`, {extra: json});
            return false;
          }
        }
        return true;
      }

      function validateItems(keys) {
        for (const item of Array.from(json)) {
          if (!validateItem(item, keys)) {
            return false;
          }
        }
        return true;
      }

      switch (type) {
        case SOURCES_MIME_TYPE:
          if (validateItems(SOURCE_KEYS)) {
            return true;
          }
          break;

        case FILES_MIME_TYPE:
          if (validateItems(FILE_KEYS)) {
            return true;
          }
          break;

        case TFI_MIME_TYPE:
          if (validateItems(TFI_KEYS)) {
            return true;
          }
          break;

        default:
          logging.warn(`Unexpected type: ${type}`, {extra: {json}});
          return false;
      }
    },
  };
}

// eslint-disable-next-line no-restricted-syntax
_.extend(BenchlingData, {SOURCES_MIME_TYPE, FILES_MIME_TYPE, TFI_MIME_TYPE});

export default BenchlingData;
